import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6169434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-creation-form__content" }
const _hoisted_2 = { class: "organization-creation-form__content-wrapper" }
const _hoisted_3 = { class: "organization-creation-form__row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Название")
const _hoisted_5 = { class: "organization-creation-form__row" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Адрес")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Телефон")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Сайт")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("ИНН")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Уровень доступа")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Ограниченный ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Полный")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Партнёр")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Тип")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Дата договора:")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "organization-creation-form__text" }, "Настройка подписки", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "organization-creation-form__small-text" }, "Индекс налёта:", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Доступно:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Тариф")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Длительность подписки")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Количество отчетов в месяц")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Ежемесячная стоимость")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Стоимость отчета при перерасходе")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Годовая стоимость")
const _hoisted_25 = { class: "organization-creation-form__subscription" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "organization-creation-form__text" }, "Выбор сервисов", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Индекс налёта")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Пародонтальный отчёт ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Скрининг")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Карта Ёршиков")
const _hoisted_31 = { class: "organization-creation-form__upload" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Загрузить логотип")
const _hoisted_33 = { class: "organization-creation-form__image-remove" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "organization-creation-form__submit" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Сохранить данные ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "organizationCreationForm",
    model: _ctx.organizationCreationFormData,
    rules: _ctx.organizationCreationValidationRules,
    class: "organization-creation-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              prop: "name",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.address)), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  ref: "nameRef",
                  modelValue: _ctx.organizationCreationFormData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organizationCreationFormData.name) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              prop: "address",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.phone)), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  ref: "addressRef",
                  modelValue: _ctx.organizationCreationFormData.address,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.organizationCreationFormData.address) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "phone",
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.site)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "phoneRef",
                        modelValue: _ctx.organizationCreationFormData.phone,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organizationCreationFormData.phone) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "site",
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.inn)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "siteRef",
                        modelValue: _ctx.organizationCreationFormData.site,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.organizationCreationFormData.site) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "inn",
                    onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.isBlocked)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "innRef",
                        modelValue: _ctx.organizationCreationFormData.inn,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.organizationCreationFormData.inn) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "is-test",
                    onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.partner)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "isBlockedRef",
                        modelValue: _ctx.organizationCreationFormData.isTest,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.organizationCreationFormData.isTest) = $event)),
                        placeholder: " "
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: 1,
                            label: "Ограниченный"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            value: 0,
                            label: "Полный"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "partner",
                    onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.dealDate)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "partnerRef",
                        clearable: "",
                        placeholder: " ",
                        modelValue: _ctx.organizationCreationFormData.partner,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.organizationCreationFormData.partner) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: "dentalpro",
                            label: "DentalPro"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "is-test" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "statusRef",
                        clearable: "",
                        placeholder: " ",
                        modelValue: _ctx.organizationCreationFormData.status,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.organizationCreationFormData.status) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ORGANIZATION_STATUSES, (statusName, statusKey) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: statusKey,
                              label: statusName
                            }, null, 8, ["value", "label"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "dealDate",
                    onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.blockDate)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "dealDateRef",
                        modelValue: _ctx.organizationCreationFormData.dealDate,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.organizationCreationFormData.dealDate) = $event)),
                        class: "organization-creation-form__date",
                        type: "date"
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_16,
          _hoisted_17,
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "blockDate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "blockDateRef",
                        modelValue: _ctx.organizationCreationFormData.blockAt,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.organizationCreationFormData.blockAt) = $event)),
                        class: "organization-creation-form__date",
                        type: "date"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "packageCount" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "packageCountRef",
                        modelValue: _ctx.organizationCreationFormData.packageCount,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.organizationCreationFormData.packageCount) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "tariffId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "tariffIdRef",
                        placeholder: " ",
                        modelValue: _ctx.organizationCreationFormData.tariffId,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.organizationCreationFormData.tariffId) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_19
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffList, (tariff) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: tariff.id,
                              label: tariff.display_title
                            }, null, 8, ["value", "label"]))
                          }), 256)),
                          _createVNode(_component_el_option, {
                            value: "-1",
                            label: "Индивидуальный"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "organization-creation-form__item",
                    prop: "subscriptionType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "subscriptionTypeRef",
                        placeholder: " ",
                        modelValue: _ctx.organizationCreationFormData.subscriptionType,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.organizationCreationFormData.subscriptionType) = $event))
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_20
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: "monthly",
                            label: "Месячная"
                          }),
                          _createVNode(_component_el_option, {
                            value: "yearly",
                            label: "Годовая"
                          }),
                          _createVNode(_component_el_option, {
                            value: "trimonthly",
                            label: "Трехмесячная"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (_ctx.organizationCreationFormData.customTariffData)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: "organization-creation-form__item",
                        prop: "customTariffData.report_count",
                        onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => (
                _ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.customTariffReportCount)
              ), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "number",
                            ref: "{{ INPUT_NAMES.customTariffReportCount }}",
                            disabled: !_ctx.organizationCreationFormData.useCustomTariff,
                            modelValue: 
                  _ctx.organizationCreationFormData.customTariffData.report_count
                ,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
                  _ctx.organizationCreationFormData.customTariffData.report_count
                ) = $event)),
                            modelModifiers: { number: true }
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (_ctx.organizationCreationFormData.customTariffData)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: "organization-creation-form__item",
                        prop: "customTariffData.price_month",
                        onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (
                _ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.customTariffPriceMonth)
              ), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "number",
                            ref: "{{ INPUT_NAMES.customTariffPriceMonth }}",
                            disabled: !_ctx.organizationCreationFormData.useCustomTariff,
                            modelValue: 
                  _ctx.organizationCreationFormData.customTariffData.price_month
                ,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                  _ctx.organizationCreationFormData.customTariffData.price_month
                ) = $event)),
                            modelModifiers: { number: true }
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "organization-creation-form__row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (_ctx.organizationCreationFormData.customTariffData)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: "organization-creation-form__item",
                        prop: "customTariffData.price_over",
                        onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (
                _ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.customTariffPriceOver)
              ), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "number",
                            ref: "{{ INPUT_NAMES.customTariffPriceOver }}",
                            disabled: !_ctx.organizationCreationFormData.useCustomTariff,
                            modelValue: 
                  _ctx.organizationCreationFormData.customTariffData.price_over
                ,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((
                  _ctx.organizationCreationFormData.customTariffData.price_over
                ) = $event)),
                            modelModifiers: { number: true }
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  (_ctx.organizationCreationFormData.customTariffData)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: "organization-edition-form__item",
                        prop: "customTariffData.price_year",
                        onKeyup: _cache[28] || (_cache[28] = _withKeys(($event: any) => (
                _ctx.handleChangeFocusedInput(_ctx.INPUT_NAMES.customTariffPriceYear)
              ), ["enter"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "number",
                            ref: "{{ INPUT_NAMES.customTariffPriceYear }}",
                            disabled: !_ctx.organizationCreationFormData.useCustomTariff,
                            modelValue: 
                  _ctx.organizationCreationFormData.customTariffData.price_year
                ,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((
                  _ctx.organizationCreationFormData.customTariffData.price_year
                ) = $event)),
                            modelModifiers: { number: true }
                          }, {
                            prefix: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.organizationCreationFormData.modules,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.organizationCreationFormData.modules) = $event)),
              class: "organization-creation-form__checkboxes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: "plaque" }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "periodontology" }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "screening" }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: "brushmap" }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_el_upload, {
              "auto-upload": false,
              "file-list": _ctx.images,
              limit: 1,
              "on-change": _ctx.handleUploadFile,
              "on-exceed": _ctx.handleExceed,
              accept: "image/*",
              "list-type": "picture"
            }, {
              file: _withCtx(({ file }) => [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_icon_template, {
                    height: "17",
                    name: "remove-photo",
                    width: "17",
                    onClick: ($event: any) => (_ctx.handleRemoveImage(file))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("img", {
                  src: file.url,
                  class: "organization-creation-form__image"
                }, null, 8, _hoisted_34)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  round: "",
                  type: "default"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["file-list", "on-change", "on-exceed"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_el_button, {
          class: "organization-creation-form__submit-button",
          round: "",
          type: "primary",
          onClick: _ctx.handleSubmitForm
        }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}